import {Outlet} from 'react-router-dom';

const AuthLayout = (props) => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default AuthLayout;
